import type { IconSvgObject } from './types';

const MountainIcon: IconSvgObject = [
  ["path", { d: "M16 20H2L7.11228 5.34385C7.73729 3.55205 10.2627 3.55205 10.8877 5.34385L12.5 9.96602", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 20H22L15.7033 9.93615C14.9223 8.68795 13.0777 8.68795 12.2967 9.93615L9.12837 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MountainIcon;
